module.exports = __webpack_public_path__ + "img/italian-serie-a-34.2a8bba8b.png";